import {BrowserRouter, Route, RouteChildrenProps, RouteProps, useLocation} from "react-router-dom";
import React, {createContext, FC, useContext} from "react";
import {History} from "history";
import {JustChildren} from "../types";
import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import Home from "../containers/Home";
import {ENV} from "./constants";

const RouterContext = createContext<RouteChildrenProps>({} as RouteChildrenProps);

export let routerTools: History;

export const ProtectedRoute = ({ component, ...args }: RouteProps) => (
    <Route component={withAuthenticationRequired(component as React.ComponentType)} {...args} />
);

export const ProtectedVerifiedRoute = ({ component, ...args }: RouteProps) => {
    const {user} = useAuth0();


    if (!user?.email_verified) {
        return <ProtectedRoute {...args} component={Home} />
    } else {
        return <ProtectedRoute component={component} {...args} />;
    }

}

export const HookedBrowserRouter: FC<JustChildren> = ({ children }: JustChildren) => (
    <BrowserRouter>
        <Route>
            {(routeProps: RouteChildrenProps) => {
                routerTools = routeProps.history;
                return <RouterContext.Provider value={routeProps}>
                    {children}
                </RouterContext.Provider>;
            }}
        </Route>
    </BrowserRouter>
);

/**
 * This hook can be used in any component inside the HookedBrowserRouter
 * to retrieve route properties like: location
 */
export function useRouter() {
    return useContext(RouterContext);
}

/**
 * This hook can be used in any component inside the HookedBrowserRouter
 * to get the query parameters' Map
 */
export function useQuery(): URLSearchParams {
    return new URLSearchParams(useLocation().search);
}


export const Routes = {
    ALL: "*",
    HOME: "/",
    USER_ACCOUNT: "/user/account",
    HTML: "/html",
    PDF: "/pdf",
    AES: "/aes",
    PDF_SIMPLE: "/pdfsimple",
    PDF_SIMPLE_OTP: "/pdfsimpleotp",
    TIMESTAMP: "/timestamp",
    DATA: "/data",
    API_KEYS: "/apikeys",
    CALL_ARCH: "/callarchs",

    STORE: `https://${(ENV && ENV !== "prod") ? `${ENV}.` : ""}store.kopjra.com/web-trust`,
    DOCS: "https://webtrust.kopjra.com/apidoc/index.html",
    VALIDATOR: "https://validator.webtrust.kopjra.com/",
}
export type RouteType = typeof Routes[keyof typeof Routes];
